import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getEventsinner } from "../Service/Api";
import FilterContainer from "../utlis/FilterContainer";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";

function EventInner() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );

  const {
    data: eventData = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["getEventsinner"],
    queryFn: getEventsinner,
  });

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthOptions = ["All", ...monthNames];

  // 🧮 Date formatter
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";
    const day = date.getDate().toString().padStart(2, "0");
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  // 🔍 Filtering logic
  const filterData = eventData.filter((item) => {
    const date = new Date(item.date);
    const itemYear = date.getFullYear().toString();
    const itemMonth = monthNames[date.getMonth()];

    const matchYear = selectedYear === "All" || itemYear === selectedYear;
    const matchMonth = selectedMonth === "All" || itemMonth === selectedMonth;
    const matchSearch =
      item.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchQuery.toLowerCase());

    return matchYear && matchMonth && matchSearch;
  });

  // 🧠 Handle loading and empty data
  const event_dummy_data = [
    { title: "Event Title", img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/events.jpg" },
  ];

  const eventList =
    isError || !eventData || eventData.length === 0
      ? event_dummy_data
      : eventData;

  // 🗓️ Unique year range list
  const yearRanges = [
    ...new Set(
      eventList
        .map((item) => {
          const d = new Date(item.date);
          return !isNaN(d) ? d.getFullYear().toString() : null;
        })
        .filter(Boolean)
    ),
  ].sort((a, b) => b - a);

  useEffect(function () {
    document.title = "Events";
  }, []);
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">Events</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Events</h1>
            </div>
          </div>

          <FilterContainer
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            yearRanges={yearRanges}
            monthOptions={monthOptions}
            totalCount={filterData.length}
          />
        </div>

        <div className="container">
          <div className="row years year2024 showYear">
            {isLoading ? (
              <p className="text-center text-muted py-5">Loading events...</p>
            ) : filterData.length > 0 ? (
              [...filterData] // create a shallow copy before sorting (avoid mutating state)
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((item, index) => (
                  <div
                    className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount"
                    key={index}>
                    <div className="eventsnewsbox">
                      <div className="newsboximg">
                        <LazyLoad
                          offset={10}
                          placeholder={
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/events.jpg"
                              alt="Loading..."
                              className="img-fluid"
                            />
                          }>
                          <img
                            src={
                              item?.images?.length
                                ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images[0]}`
                                : "Images/events.jpg"
                            }
                            className="img-fluid"
                            alt={item.title || "Event"}
                            onError={(e) => {
                              e.target.onerror = null; // prevent infinite loop
                              e.target.src = "Images/events.jpg";
                            }}
                          />
                        </LazyLoad>
                      </div>

                      <div className="newsboxdesc">
                        <div className="newspgh">
                          <h5>{item.title}</h5>
                          <p>{item.description}</p>
                          {/* <span>
                            <b>Location:</b> {item.venue || "N/A"}
                          </span> */}
                        </div>

                        <div className="newsdate">
                          <span>
                            <i className="bi bi-calendar"></i>{" "}
                            {formatDate(item.date)}
                          </span>
                          <span>
                            <i className="bi bi-alarm"></i> {item.time || "N/A"}
                          </span>
                          {item?.attachments?.length ? (
                            <Link
                              to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                              target="_blank">
                              <i className="bi bi-paperclip"></i>
                            </Link>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount">
                <div className="eventsnewsbox">
                  <div className="newsboximg">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/events.jpg"
                      className="img-fluid"
                      alt="Frank Anthony Bangalore"
                    />
                  </div>
                  <div className="newsboxdesc">
                    <div className="newspgh">
                      <h5>Stay tuned for latest updates</h5>
                      <p>Check back soon for new events and activities.</p>
                      <span>
                        <b>Location:</b> School
                      </span>
                    </div>
                    <div className="newsdate">
                      <span>
                        <i className="bi bi-calendar"></i> DD/MM/YYYY
                      </span>
                      <span>
                        <i className="bi bi-alarm"></i> --
                      </span>
                      <i className="bi bi-paperclip text-muted"></i>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EventInner;
